import React, { Fragment, useState } from "react";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import AxiosConfig from "axiosConfig";
import "containers/Projects/Details/ProjectDetails.css";
import Button from "react-bootstrap/Button";
import "../../../../node_modules/video-react/dist/video-react.css";
import cookie from "react-cookies";
import "containers/ProjectCommon.css";
import ProjectBanner from "components/Project/ProjectBanner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import Collapsible from "react-collapsible";
import { ButtonDropdown } from "reactstrap";
import TextTheme from "../../../components/General/Text/TextTheme";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
// import {getCurrentDate} from './utils'
import moment from "moment";
import CollapseComponent from "../../../components/Spotlight/CollapseComponent";

class ProjectDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectMission: "",
      projectGoal: "",
      projectVideoName: "",
      projectVideo: "",
      projectBanner: "",
      projectName: "",
      userEmail: cookie.load("user_email"),
      projectPinterest: "",
      projectFiles: "",
      projectFileNames: "",
      challengeName: "",
      goalDate: "",
      projectUserId: undefined,
      projectExploration: "",
    };
  }

  componentDidMount() {
    const projectSlug = this.props.match.params.slug;
    Promise.all([
      AxiosConfig.get(`/impactprojects/project/${projectSlug}/`),
      AxiosConfig.get(
        `/impactprojects/active_challenge_details/${projectSlug}`
      ),
    ])
      .then(([res1, res2]) => {
        if (res1) {
          this.setState({
            projectMission: res1.data.mission,
            projectName: res1.data.name,
            projectExploration: res1.data.exploration,
            projectReferences: res1.data.references,
            projectBanner: res1.data.banner,
            projectGoal: res1.data.goal,
            projectVideoName: res1.data.project_video_name,
            projectVideo: res1.data.video,
            projectPinterest: res1.data.pinterest,
            projectFiles: res1.data.uploads,
            projectFileNames: res1.data.uploads.map(function (value) {
              return value.name;
            }),
            projectFileUrls: res1.data.uploads.map(function (value) {
              return value.upload;
            }),
          });
        }
        if (res2.data.length > 0) {
          let goal_Date = new Date();
          goal_Date.setTime(new Date(res2.data[0].goal_date).getTime() + (new Date(res2.data[0].goal_date).getTimezoneOffset() * 60 * 1000));
          this.setState({
            challengeName: res2.data[0].challenge.slug,
            goalDate: goal_Date,
            projectUserId: res2.data[0].project_user_id,
          });
        } else {
          this.setState({
            challengeName: undefined,
            goalDate: undefined,
            projectUserId: undefined,
          });
        }
      })
      .catch();
  }

  onSubmit() {
    const projectSlug = this.props.match.params.slug;
    this.props.history.push({
      pathname: `/projects/${projectSlug}/challenges`,
      state: {
        challengeSlug: this.state.challengeName || undefined,
        adventureId: undefined,
        adventureSlug: undefined,
        goalDate: this.state.goalDate,
        projectUserId: this.state.projectUserId,
      },
    });
  }
  onJoinProject() {
    const projectSlug = this.props.match.params.slug;
    this.props.history.push({
      pathname: `/projects/${projectSlug}/challenges`,
      state: {
        challengeSlug: this.props.location.state.challengeSlug,
        adventureId: this.props.location.state.adventureId,
        adventureSlug: this.props.location.state.adventureSlug,
        isInvite: this.props.location.state.isInvite,
        email: this.props.location.state.email,
        invitationId: this.props.location.state.invitationId,
      },
    });
  }
  onSkipClicked() {
    this.props.history.push({ pathname: `/projects/` });
  }

  returnAttatchment = (x) => {
    return (
      <div className="rowattachment">
        <FontAwesomeIcon
          rotation={90}
          icon={faPaperclip}
          color="#1A3867"
          style={{ marginRight: "10px" }}
        />
        <a
          href={x.upload}
          target="_blank"
          rel="noreferrer"
          style={{ color: "#1A3867" }}
          download
        >
          {x.name}
        </a>
      </div>
    );
  };

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  render() {
    return (
      <div className="header_main">
        <link
          href="//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.css"
          rel="stylesheet"
        ></link>
        <div className="page_main">
          <div className="page_info_vr_content_main">
            <ProjectOldInfo
              vertical={true}
              project={this.props.match.params.slug}
            />
          </div>

          <div className="page_details_main">
            <div className="project-banner">
              <ProjectBanner image={this.state.projectBanner} />
            </div>
            <div className="page_info_hr_content_main">
              <ProjectOldInfo project={this.props.match.params.slug} />
            </div>
            <div className="page_details_content_main mt-15">
              <div className="projectNameFormat">
                <h2 className="textHeader">{this.state.projectName}</h2>
              </div>
              <div className="project-details">
                <h3 className="textHeader">Mission</h3>
                <div
                  className="insideContent"
                  dangerouslySetInnerHTML={{
                    __html: this.state.projectMission,
                  }}
                ></div>
                {this.state.projectExploration !== "" ? (
                  <Fragment>
                    <h3 className="textHeader">Project Exploration</h3>
                    <div
                      className="insideContent project-exploration"
                      dangerouslySetInnerHTML={{
                        __html: this.state.projectExploration,
                      }}
                    ></div>
                    <CollapseComponent
                      title="References"
                      projectReferences={this.state.projectReferences}
                    />
                  </Fragment>
                ) : null}
              </div>
              {this.props.location.state &&
                this.props.location.state.isInvite ? (
                <div className="mt-15 text-right join-btn-container">
                  <RoundedButton
                    title="No, maybe later."
                    buttonClassName="background_white"
                    textThemeClassName="text_medium text_dark_orange"
                    handleOnClick={this.onSkipClicked.bind(this)}
                  />
                  <RoundedButton
                    title="Join Project"
                    buttonClassName="background_dark_orange"
                    textThemeClassName="text_medium text_white"
                    handleOnClick={this.onJoinProject.bind(this)}
                    margin="0px 5px 0px 0px"
                  />
                </div>
              ) : (
                <Button
                  onClick={this.onSubmit.bind(this)}
                  className="startButton"
                  size="lg"
                >
                  Start Project
                </Button>
              )}
            </div>
            {this.state.projectPinterest ? (
              <div className="page_details_content_main mt-15 d-flex justify-space-between align-items-baseline">
                <a
                  href={this.state.projectPinterest}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="textHeader"
                >
                  Explore More
                </a>
                <a href={this.state.projectPinterest} target="_blank">
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    color="#1A3867"
                    style={{ marginRight: "10px", float: "right" }}
                  />
                </a>
              </div>
            ) : null}
            {this.state.projectFiles.length !== 0 ? (
              <div className="page_details_content_main mt-15">
                <h2 className="textHeader">Project Attatchments</h2>
                {[...this.state.projectFiles].map((x) =>
                  this.returnAttatchment(x)
                )}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
export default ProjectDetails;
